// """  URL for Generic RESET password for exist client's account
//
//      endpoint: /account/reset
//
//      post: Sets client's email for reset password sending email
//            payload in the request body
// """
export const ResetPasswordUrl = () => {
  return '/account/reset'
}
// """  URL for Generic Update password for exist client's account
//
//      endpoint: /password
//
// """
export const UpdatePasswordUrl = () => {
  return '/password'
}
